import React from 'react';
import { Button } from '@mui/material';

const CancelButton = ({ children, ...props }) => {
    return (
        <Button disableElevation disableRipple color="default" {...props}>
            {children}
        </Button>
    );
};

export default CancelButton;
